/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "urlbuilderapi",
            "endpoint": "https://i73e6hd34e.execute-api.eu-west-1.amazonaws.com/dev",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:40d8bc81-1e3b-4619-8864-2b36686b7b38",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_zJ3YXRQBp",
    "aws_user_pools_web_client_id": "4fh4t9ocvkbsbo4ghrva9ihfng",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "campaignsReferential-dev",
            "region": "eu-west-1"
        },
        {
            "tableName": "urlreferential-dev",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
